module.exports = __webpack_public_path__ + "img/big_six_bg.b651df96.png";